let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4P0B3")).then(() => parcelRequire('7iMXE'));